// Packages
import React, { useState, useRef, useEffect } from "react";
import UseAnimations from "react-useanimations";
import Picker from "emoji-picker-react";
import { gql } from "@apollo/client";
// Components
import { apolloClient } from "../../../index";
import { getIntials, getName, getParsedDate } from "../../../helper";
import ProfileWithName from "../../ListView/ListViewRows/ProfileWithName/ProfileWIthName";
import EmojiCard from "../../UI/EmojiCard/EmojiCard";
import { notify } from "../../Notify/Notify";
// Assets
import fileIcon from "../../../assets/icons/file_pdf.svg";
import smileIcon from "../../../assets/icons/smile.svg";
import replyIcon from "../../../assets/icons/comment-reply.svg";
// scss file
import "./DocumentComments.scss";
// Animations
import download from "react-useanimations/lib/download";
import arrowUpCircle from "react-useanimations/lib/arrowUpCircle";
import trash from "react-useanimations/lib/trash2";
import edit from "react-useanimations/lib/edit";

const CommentDisplay = (props) => {
  const {
    commentObj,
    isSubComment,
    currentUserInfo,
    editMode,
    showReplySection,
  } = props;
  const [showActionIcon, setShowActionIcon] = useState(true);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [commentReactionItems, setCommentReactionItems] = useState({});
  const actionRef = useRef(null);

  // Handle open and close of emoji picker
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutsideOfEmojiSelecion);
    modifiyEmojiReaction(commentObj.commentReaction);
    if (editMode || showReplySection) {
      setShowActionIcon(false);
    } else {
      setShowActionIcon(true);
    }
    return () => {
      document.removeEventListener(
        "mousedown",
        handleClickOutsideOfEmojiSelecion
      );
    };
  }, [commentObj, editMode, showReplySection]);

  // Handle outside click
  const handleClickOutsideOfEmojiSelecion = (event) => {
    if (
      actionRef &&
      actionRef.current &&
      !actionRef.current.contains(event.target)
    ) {
      setShowEmojiPicker(false);
      actionRef.current.classList.contains("show") &&
        actionRef.current.classList.remove("show");
    }
  };

  // Handle icon click to open emoji picker
  const emojiPickerHandler = () => {
    let isEmojiPickerOpen = !showEmojiPicker;
    setShowEmojiPicker(!showEmojiPicker);

    if (isEmojiPickerOpen && !actionRef.current.classList.contains("show")) {
      actionRef.current.classList.add("show");
    } else if (
      !isEmojiPickerOpen &&
      actionRef.current.classList.contains("show")
    ) {
      actionRef.current.classList.remove("show");
    }
  };

  // Create emoji reaction object
  const modifiyEmojiReaction = (commentReaction) => {
    if (commentReaction.length > 0) {
      let emojiReactionItems = {};
      commentReaction.forEach((reaction) => {
        let updatedEmojiReactionItem = {};
        let updatedUserList = [];
        //Update user list
        updatedUserList = emojiReactionItems[reaction.emojiId]
          ? emojiReactionItems[reaction.emojiId]["userList"].push(
              getName(reaction.reactedBy)
            )
          : [getName(reaction.reactedBy)];
        updatedEmojiReactionItem[reaction.emojiId] = {
          emoji: reaction.emoji,
          userList: updatedUserList,
        };
        // Update emoji reaction items
        emojiReactionItems = {
          ...updatedEmojiReactionItem,
          ...emojiReactionItems,
        };
      });
      setCommentReactionItems(emojiReactionItems);
    }
  };

  // Add emoji reaction
  const addEmojiReaction = (event, emojiObject) => {
    event.preventDefault();

    const variables = {
      commentId: commentObj.id,
      emoji: emojiObject["emoji"],
      emojiId: emojiObject["unified"],
    };

    apolloClient
      .query({
        query: gql`
          mutation addEmojiReaction(
            $commentId: UUID!
            $emoji: String!
            $emojiId: String!
          ) {
            addEmojiReaction(
              commentId: $commentId
              emoji: $emoji
              emojiId: $emojiId
            ) {
              success
              emojiReactionType {
                id
                emojiId
                emoji
                reactedBy {
                  id
                  firstName
                  lastName
                }
              }
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        if (result.data.addEmojiReaction.success) {
          const emojiReactionType =
            result.data.addEmojiReaction.emojiReactionType;

          if (!commentReactionItems[emojiObject["unified"]]) {
            commentReactionItems[emojiObject["unified"]] = {
              emoji: emojiObject.emoji,
              userList: [getName(emojiReactionType.reactedBy)],
            };
          } else {
            commentReactionItems[emojiObject["unified"]]["userList"] = [
              getName(emojiReactionType.reactedBy),
              ...commentReactionItems[emojiObject["unified"]]["userList"],
            ].reverse();
          }

          commentObj.commentReaction = [
            emojiReactionType,
            ...commentObj.commentReaction,
          ];

          setCommentReactionItems({ ...commentReactionItems });
        }
      })
      .catch((e) => {
        const title = "Error";
        const detail = "Oops!! some error occurred please try again.";
        const type = "error";
        notify(title, detail, type);
      });
    setShowEmojiPicker(false);
    handleClickOutsideOfEmojiSelecion(event);
  };

  // Remove emoji reaction
  const removeEmojiReaction = (event, emojiId, emoji, reactions) => {
    event.preventDefault();
    const deleteReaction = reactions.filter(
      (reaction) =>
        reaction.emojiId === emojiId &&
        reaction.reactedBy.id === currentUserInfo.id
    )[0];

    if (deleteReaction) {
      const variables = {
        reactionId: deleteReaction.id,
      };

      apolloClient
        .query({
          query: gql`
            mutation removeEmojiReaction($reactionId: UUID!) {
              removeEmojiReaction(reactionId: $reactionId) {
                success
              }
            }
          `,
          variables: variables,
        })
        .then((result) => {
          if (result.data.removeEmojiReaction.success) {
            commentReactionItems[emojiId]["userList"] = commentReactionItems[
              emojiId
            ]["userList"].filter(
              (user) => user !== getName(deleteReaction.reactedBy)
            );
            commentReactionItems[emojiId]["userList"].length === 0 &&
              delete commentReactionItems[emojiId];
            commentObj.commentReaction = [...commentObj.commentReaction].filter(
              (reaction) => reaction !== deleteReaction
            );
            setCommentReactionItems({ ...commentReactionItems });
          }
        })
        .catch((e) => {
          const title = "Error";
          const detail = "Oops!! some error occurred please try again.";
          const type = "error";
          notify(title, detail, type);
        });
    } else {
      if (emoji) {
        const emojiObject = {
          emoji: emoji,
          unified: emojiId,
        };
        addEmojiReaction(event, emojiObject);
      }
    }
  };

  // Get Email list
  const getEmailList = (emailList) => {
    return emailList.map((email, index) => (
      <div key={index} className={`email-frame`}>
        <p>{email}</p>
      </div>
    ));
  };

  return (
    <div
      className={["comment-slide", isSubComment ? "sub-comment" : ""].join(" ")}
      style={{ boxShadow: "none", paddingBottom: "5px" }}
      key={commentObj.id}
    >
      {/* Comment header */}
      <div className={!isSubComment ? "parent-comment" : ""}>
        <div className="first-row">
          <div className="d-flex pl-1">
            {/* Comment user */}
            <ProfileWithName
              nameIntial={getIntials(commentObj.createdBy)}
              personName={getName(commentObj.createdBy)}
              profile={commentObj.createdBy.profile.image}
              isPopover={true}
              role={
                commentObj.createdBy.profile
                  ? commentObj.createdBy.profile.role.name
                  : ""
              }
            />

            {/* Comment timestamp */}
            <span className="timestamp">
              {getParsedDate(commentObj.createdTs)}
            </span>
          </div>
          
          {/* Comment action icons */}
          {showActionIcon && !props.archiveView ? (
            <div
              className={[
                "align-items-center",
                isSubComment ? "sub-comment-action" : "comment-action",
              ].join(" ")}
              ref={actionRef}
            >
              <div className="custom-emoji">
                {showEmojiPicker && <Picker onEmojiClick={addEmojiReaction} />}
              </div>

              {/* Comment emoji reply */}
              <img
                className="comment-emoji-reply-icon"
                onClick={() => emojiPickerHandler()}
                src={smileIcon}
                alt="smile"
              />

              {/* Comment reply */}
              {!isSubComment ? (
                <img
                  className="comment-reply-icon"
                  onClick={props.onCommentReply}
                  src={replyIcon}
                  alt="file"
                />
              ) : null}

              {currentUserInfo &&
              commentObj.createdBy &&
              currentUserInfo.id === commentObj.createdBy.id ? (
                <>
                  {/* Comment edit */}
                  <UseAnimations
                    className="comment-edit-icon"
                    animation={edit}
                    strokeColor="#9d9da0"
                    onClick={() => props.onEditCommentHandler(commentObj)}
                  />

                  {/* Comment delete */}
                  <UseAnimations
                    className="comment-delete-icon"
                    animation={trash}
                    strokeColor="#9d9da0"
                    onClick={() => props.onDeleteCommentHandler(commentObj)}
                  />
                </>
              ) : null}
            </div>
          ) : null}
        </div>

        {/* Comment content */}
        <div className="content-row mx-8">
          <p
            className="comment-text"
            dangerouslySetInnerHTML={{
              __html: commentObj.comment,
            }}
          ></p>
        </div>

        {/* Comment attachments */}
        <div className="mx-6">
          {commentObj.noteAttachment.length > 0 && (
            <div className="attachment-section">
              {commentObj.noteAttachment.map((file) => (
                <div className="attachment-item">
                  <div className="attachment-file-icon">
                    <img src={fileIcon} alt="file" />
                  </div>
                  <div className="attachment-description">
                    <label className="attachment-name is-size-body-1 bold">
                      {file.name}
                    </label>
                    <label className="attachment-size .is-size-body-2 bold">
                      {props.formatBytes(file.size)}
                    </label>
                  </div>
                  {!file.uploading ? (
                    <div className="attachment-download-icon ml-auto">
                      <a
                        href={file.attachmentFileUrl}
                        fileName={file.name}
                        download
                      >
                        <UseAnimations animation={download} />
                      </a>
                    </div>
                  ) : (
                    <div className="ml-auto">
                      <UseAnimations
                        animation={arrowUpCircle}
                        autoplay={true}
                        loop={true}
                        strokeColor="Blue"
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Comment mention */}
      <div className="content-row mx-8">
        {commentObj.emailList.length > 0 ? (
          <div className="emails">{getEmailList(commentObj.emailList)}</div>
        ) : null}
      </div>

      {/* Comment reaction */}
      <div className="emoji-reaction-section d-flex">
        {Object.keys(commentReactionItems).map((emojiId, index) => (
          <EmojiCard
            index={index}
            emojiReaction={commentReactionItems[emojiId]}
            removeEmojiReaction={(event) =>
              removeEmojiReaction(
                event,
                emojiId,
                commentReactionItems[emojiId]
                  ? commentReactionItems[emojiId]["emoji"]
                  : null,
                commentObj.commentReaction
              )
            }
          />
        ))}
      </div>

      {/* Comment sub-comment */}
      {commentObj.documentnoteSet.length > 0
        ? commentObj.documentnoteSet.map((subComment) => (
            <CommentDisplay
              commentObj={subComment}
              isSubComment={true}
              editMode={editMode}
              showReplySection={showReplySection}
              formatBytes={props.formatBytes}
              onDeleteCommentHandler={() =>
                props.onDeleteCommentHandler(subComment)
              }
              onEditCommentHandler={() =>
                props.onEditCommentHandler(subComment)
              }
              currentUserInfo={props.currentUserInfo}
            />
          ))
        : null}
    </div>
  );
};

export default CommentDisplay;
